import { createFileRoute, redirect } from "@tanstack/react-router";

import { resolveWorkspaceLandingRoute } from "@/features/workspace-router";

/**
 * ``/workspace`` bare — resume last workspace tab (mirrors ``_authed/`` for
 * the ``/workspace`` prefix served to the SPA in prod).
 *
 * Post-login target for the BFF (``apps/web``): unified single-domain routing
 * splits paths at the Gateway (``k8s/gateway/http-routes.yaml``) so ``/`` goes
 * to the marketing ``ando-web`` and ``/workspace/*`` to this SPA. Landing on
 * ``/workspace`` alone would 404 without this entry.
 */
export const Route = createFileRoute("/_authed/workspace/")({
  beforeLoad: () => {
    throw redirect({ to: resolveWorkspaceLandingRoute() });
  },
});
